<div class="modal-header">
    <h2 class="modal-title">{{'asset.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()"></button>
</div>

<div class="modal-body">
    <div class="filter-section pb-3 mb-4">
        <div class="fw-semibold mb-3">
            {{ "contracts.filterModal.contractCategoriesTitle" | translate }}
        </div>
        <div class="row">
            <div *ngFor="let contractType of contractTypes"
                class="col-md-6 d-flex align-items-center mb-3">
                <input
                    type="checkbox"
                    kendoCheckBox
                    [size]="size"
                    [id]="contractType.value"
                    [rounded]="roundedLarge"
                    [(ngModel)]="contractType.isSelected"
                />
                <label HJSuppress [for]="contractType.value" class="cursor-pointer ms-2">
                    {{ contractType.name }}
                </label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 fw-semibold mb-3">
            {{'asset.contractPopup.' + (pageFilter.activeContracts ? 'active' : 'inactive') | translate}}
        </div>
        <div *ngFor="let contract of contracts" class="col-md-6" (click)="contractHandler(contract.contractId)">
            <div class="filter-container">
                <div class="category-entry">
                    <div class="d-flex align-items-center">
                        <input type="checkbox" kendoCheckBox [size]="size" [rounded]="roundedLarge"
                            [(ngModel)]="contract.isSelected"/>
                        <div HJSuppress class="category-txt fw-semibold">{{contract.number}}</div>
                    </div>
                    <div HJSuppress class="contract-second-row fw-bold">
                        {{'asset.contractPopup.start' | translate}} {{contract?.startDate | localizedDate}} -
                        {{'asset.contractPopup.end' | translate}} {{contract?.endDate | localizedDate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'asset.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyHandler()">
        {{'asset.filterPopup.apply' | translate}}
    </button>
</div>
